module.exports = __webpack_public_path__ + "static/media/cachorroquente.d40915b8.webp";